import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "timi-projectdetail-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "--", -1)
const _hoisted_3 = { class: "show-all-link" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "4:12 h", -1)
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ListItem = _resolveComponent("ListItem")!
  const _component_List = _resolveComponent("List")!

  return (_ctx.project && _ctx.project.uid)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Button, {
          text: _ctx.$t('button.back'),
          dense: true,
          onClick: _ctx.handleGoBack
        }, null, 8, ["text", "onClick"]),
        _createElementVNode("h2", null, _toDisplayString(_ctx.project.title), 1),
        _createVNode(_component_ListItem, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('label.client')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.project.customer.custName), 1)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('label.hours')), 1),
        (_ctx.project.uid)
          ? (_openBlock(), _createBlock(_component_List, {
              key: 0,
              raised: true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeEntries, (entry) => {
                  return (_openBlock(), _createBlock(_component_ListItem, {
                    key: entry.uid
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(entry.work.title), 1),
                      _hoisted_2
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createElementVNode("p", _hoisted_3, [
                  _createElementVNode("a", null, _toDisplayString(_ctx.$t('button.showAll')), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('label.totalTime')), 1),
                  _hoisted_5
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, " Loading... "))
}